import * as React from 'react';
import { IRestCardListActivity } from '../../../../../../../types/rest/activity/IRestCardListActivity';
import { IActivityProps } from '../../../../boardDetails/activity/TabActivity/types';
import { TabActivityContext } from '../../../../boardDetails/activity/TabActivity/components/TabActivity/constants';
import './_CardActivityList.scss';
import { TActivity } from '../../../../../../../store/activities/types';
import {
    ActivityItemBody
} from '../../../../boardDetails/activity/TabActivity/components/ActivityItemBody/ActivityItemBody';
import { CLASS_ACTIVITY_ITEM } from '../../../../boardDetails/activity/TabActivity/components/constants';
import { ActivityHeader } from '../../../../boardDetails/activity/TabActivity/components/ActivityHeader/ActivityHeader';
import {
    ActivityItemName
} from '../../../../boardDetails/activity/TabActivity/components/ActivityItemName/ActivityItemName';
import { Icon } from 'kui';
import { Logo } from '../../../../../base/components/Logo/components/Logo/Logo';
import { AnalyzeRender } from '../../../../../helpers/memoizeHelper';
// @ts-ignore
const analyzeRender = window.Settings.development ? new AnalyzeRender(`CardActivityList`) : null;

export function CardActivityList({
    activity
}: IActivityProps<IRestCardListActivity>) {
    if (analyzeRender) analyzeRender.call(activity.id);
    const { onScrollToList } = React.useContext(TabActivityContext);
    const isShowBoardName = activity.newBoard && activity.oldBoard && activity.newBoard.id !== activity.oldBoard.id;
    const { label } = activity as TActivity;

    const classLogo = CLASS_ACTIVITY_ITEM + '__logo';

    const getLogo = (
        logo: string,
        logoColor: string,
        logoIcon: string,
        boardName: string
    ) => {
        return logo ? <div
                className={`${classLogo} ${classLogo}--custom`}
                style={{ backgroundImage: `url("${logo}")` }}
            />
            : <Logo
                name={boardName}
                logo={{ icon: logoIcon, color: logoColor }}
            />
    }

    return (
        <ActivityItemBody
            className={`${CLASS_ACTIVITY_ITEM + '--list'} ${isShowBoardName ? CLASS_ACTIVITY_ITEM + '--list-with-board' : ''}`}
            header={<ActivityHeader label={label} activity={activity} />}
            activity={activity}
            onClick={() => onScrollToList(activity.newList.id)}
        >
            {isShowBoardName &&
                <ActivityItemName
                    name={activity.oldBoard.name}
                    isRemove
                    icon={getLogo(activity.oldBoard.logo, activity.oldBoard.logoColor, activity.oldBoard.logoIcon, activity.oldBoard.name)}
                />
            }
            <ActivityItemName name={activity.oldList.name} isRemove icon={<Icon size={16} xlink={'list-view'} />} />
            <Icon xlink={'forward'} size={24} />
            {isShowBoardName &&
                <ActivityItemName
                    name={activity.newBoard.name}
                    icon={getLogo(activity.newBoard.logo, activity.newBoard.logoColor, activity.newBoard.logoIcon, activity.newBoard.name)}
                />
            }
            <ActivityItemName name={activity.newList.name} icon={<Icon size={16} xlink={'list-view'} />} />
        </ActivityItemBody>
    );
};
